import { configure } from './configure'

const boostrap = async () => {
  const appId = window.Specific.appId

  if (!appId) {
    // eslint-disable-next-line no-restricted-syntax
    throw new Error('Specific appId is required')
  }

  void configure(window.Specific)
}

void boostrap()
